var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stack-list"},[_c('div',{staticClass:"stack-list__list"},_vm._l((_vm.items),function(item,i){return _c('div',{key:("stack-" + i),staticClass:"stack-list__item",domProps:{"textContent":_vm._s(item)}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }